module.exports = __webpack_public_path__ + "images/account_setups/icon-project-calendar-view-4a47e4de859a8f4e7d73143162b98c35.png";